import { adminHttpClient } from '../commons/adminHttpClient'
import { ReimbursementRequestType } from './getAllCompanyReimbursementRequests'

export type GetAllReimbursementsAsCsvRequest = {
  reimbursementType: ReimbursementRequestType
  planPeriodId: string
  fromDate?: string
  toDate?: string
  q: string
}

const getAllCompanyReimbursementRequestsAsCsv = (request: GetAllReimbursementsAsCsvRequest): Promise<string> =>
  adminHttpClient.get('Expenses/AllCompanyRequestsAsCsv', request)

export default getAllCompanyReimbursementRequestsAsCsv
